import { inject, Injectable } from '@angular/core'
import { AppIdService } from './app-id.service'

export interface AppConfigurationTranslationInformation {
  mainKeys: string[]
  plainTextKeysToTranslate: string[]
  htmlKeysToTranslate: string[]
}

interface AppConfigurationTranslationDefinition extends AppConfigurationTranslationInformation {
  appIds: string[]
}

const appConfigurationTranslationDefinitions: AppConfigurationTranslationDefinition[] = [
  {
    appIds: ['activityPlot'],
    mainKeys: ['reflectionQuestions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['acm', 'cm2', 'conceptmapper'],
    mainKeys: ['reflectionQuestions', 'concepts', 'relations'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback', 'concepts', 'relations'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['chatApp', 'Chat'],
    mainKeys: ['welcomeMessage'],
    plainTextKeysToTranslate: ['welcomeMessage'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['chatWithAI'],
    mainKeys: ['welcomeMessage', 'llmCharacterName'],
    plainTextKeysToTranslate: ['welcomeMessage', 'llmCharacterName'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['chempy', 'chempy3'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['sharedText'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['conclusionTool'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['dataSetEditor3'],
    mainKeys: ['dataSourceColumns', 'rowLabelColumnLabel', 'rowLabels'],
    plainTextKeysToTranslate: ['label', 'categoryLabels', 'rowLabels'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['dataSetViewer3'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['edt'],
    mainKeys: ['configuration', 'specification'],
    plainTextKeysToTranslate: ['resource_name', 'name'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['fillInTheBlanks'],
    mainKeys: ['fullText', 'additionalTerms', 'notExisting'],
    plainTextKeysToTranslate: ['text'],
    htmlKeysToTranslate: ['fullText'],
  },
  {
    appIds: ['geoGebraWrapper'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['hypothesis'],
    mainKeys: [
      'help',
      'values',
      'expressions',
      'operators',
      'emptyStandardHypothesisPlaceHolder',
      'emptyIfThenStandardHypothesisActionPlaceHolder',
      'emptyIfThenStandardHypothesisReactionPlaceHolder',
      'emptyLimitedHypothesisActionPlaceHolder',
      'emptyLimitedHypothesisReactionPlaceHolder',
      'emptySimpleHypothesisActionPlaceHolder',
      'emptySimpleHypothesisReactionPlaceHolder',
      'customApplicationTitle',
      'customBlocksTitle',
      'emptyExpressionText',
      'emptyVariableText',
      'customOperators', // I don't see if they are actually used
      'userDefinedValues', // I don't see if they are actually used
      'userDefinedExpressions', // I don't see if they are actually used
    ],
    plainTextKeysToTranslate: ['label', 'customText'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['nameTheFrame'],
    mainKeys: ['nameElements'],
    plainTextKeysToTranslate: ['name', 'detailText'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['noteBoard'],
    mainKeys: ['boardDefinitions'],
    plainTextKeysToTranslate: ['name'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['observationTool'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['onlineUsersVisualisation2'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['phaseTransitions'],
    mainKeys: ['reflectionQuestions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['quest', 'quiz'],
    mainKeys: ['questions'],
    plainTextKeysToTranslate: ['placeholder', 'name'],
    htmlKeysToTranslate: ['text', 'formatted'],
  },
  {
    appIds: ['questioning'],
    mainKeys: ['conditionals', 'variables'],
    plainTextKeysToTranslate: ['conditionals', 'variables'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['questionnaireConstructApp'],
    mainKeys: ['constructs'],
    plainTextKeysToTranslate: ['title', 'label'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['Quiz2', 'Questionnaire2', 'QuestionGallery'],
    mainKeys: ['questions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['reportingTool'],
    mainKeys: ['reportSectionConfigurations'],
    plainTextKeysToTranslate: ['title'],
    htmlKeysToTranslate: ['explanation'],
  },
  {
    appIds: ['speechBubble'],
    mainKeys: ['speechBubbleLabel'],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: ['speechBubbleLabel'],
  },
  {
    appIds: ['tableTool'],
    mainKeys: ['rowLabels', 'columnLabels', 'firstColumnLabel'],
    plainTextKeysToTranslate: ['rowLabels', 'columnLabels', 'firstColumnLabel'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['timeChecker'],
    mainKeys: ['reflectionQuestions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['timeplanner'],
    mainKeys: ['phaseDescriptions'],
    plainTextKeysToTranslate: ['description'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['reflect3'],
    mainKeys: ['reflectionQuestions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['timeSpentSummary'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['timeline'],
    mainKeys: ['reflectionQuestions'],
    plainTextKeysToTranslate: ['hint', 'placeholder', 'text', 'feedback'],
    htmlKeysToTranslate: ['description'],
  },
  {
    appIds: ['videoPlayer'],
    mainKeys: ['videos', 'customVideoSelectorLabel'],
    plainTextKeysToTranslate: ['name', 'customText'],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['viewer'],
    mainKeys: ['customTitle', 'customNoResourceMessage'],
    plainTextKeysToTranslate: ['customTitle', 'customNoResourceMessage'],
    htmlKeysToTranslate: [],
  },
  // labs
  {
    appIds: ['doubleSlitLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['circuitLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['geneticsLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['gravityDrop'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['photoelectricEffectLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['photosynthesisLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['predatorPreyLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['quantumTunnelingLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['trans2'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['conceptSorter'],
    mainKeys: ['categories', 'concepts'],
    plainTextKeysToTranslate: ['name'],
    htmlKeysToTranslate: [],
  },
  // the ones without anything to translate(, and have no student help)
  {
    appIds: ['calculator'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['collaborationGroupsManager'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['dashboard'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['gomodel'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['inputBox'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['padletWrapper'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['plastic'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['ride'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['salivaAndTemperatureLab'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['scratchWrapper'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['sharedWiki'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['space_oddity'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['overviewTool'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['cmdb'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['conferenceApp'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['periodic'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['quizOverview'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['ride_db'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
  {
    appIds: ['timeplanner', 'timePlanner2'],
    mainKeys: [],
    plainTextKeysToTranslate: [],
    htmlKeysToTranslate: [],
  },
]

const appIdsWithoutHelp = [
  'calculator',
  'Chat',
  'chatApp',
  'chatWithAI',
  'collaborationGroupsManager',
  'sharedText',
  'dashboard',
  'fillInTheBlanks',
  'geoGebraWrapper',
  'gomodel',
  'inputBox',
  'padletWrapper',
  'phaseTransitions',
  'plastic',
  'quest',
  'Questionnaire2',
  'questionnaireConstructApp',
  'quiz',
  'Quiz2',
  'ride',
  'salivaAndTemperatureLab',
  'scratchWrapper',
  'sharedWiki',
  'space_oddity',
  'speechBubble',
  'timeChecker',
  'timePlanner2',
  'reflect3',
  'videoPlayer',
  'viewer',
]

const appIdsWithoutReviewableCustomContent = [
  'cmdb',
  'collaborationGroupsManager',
  'conclusionTool',
  'conferenceApp',
  'dashboard',
  'gomodel',
  'inputBox',
  'onlineUsersVisualisation2',
  'overviewTool',
  'periodic',
  'plastic',
  'quizOverview',
  'ride',
  'ride_db',
  'salivaAndTemperatureLab',
  'sharedText',
  'sharedWiki',
  'timeSpentSummary',
  // the following three have only the url to their real content, the only check is whether the url is set, but that is not really content to review
  'geoGebraWrapper',
  'padletWrapper',
  'scratchWrapper',
]

export interface AppConfigurationInformation {
  appId: string
  // toolId?: string
  hasStudentHelp: boolean
  hasReviewableCustomContent: boolean
  translationInformation: AppConfigurationTranslationInformation
}

@Injectable({ providedIn: 'root' })
export class AppConfigurationInformationService {
  private readonly appIdService = inject(AppIdService)
  private readonly appIdAppConfigurationInformationMap = new Map<string, AppConfigurationInformation>()

  constructor() {
    this.setupMaps()
  }

  private setupMaps(): void {
    const appIdsWithoutHelpSet = new Set(appIdsWithoutHelp)
    const appIdsWithoutReviewableContentSet = new Set(appIdsWithoutReviewableCustomContent)
    for (const appConfigurationTranslationDefinition of appConfigurationTranslationDefinitions) {
      for (const appId of appConfigurationTranslationDefinition.appIds) {
        const hasStudentHelp = !appIdsWithoutHelpSet.has(appId)
        const isReviewable = !appIdsWithoutReviewableContentSet.has(appId)
        const helpKeyArray = hasStudentHelp ? ['help'] : []
        const appConfigurationInformation: AppConfigurationInformation = {
          appId,
          hasStudentHelp,
          hasReviewableCustomContent: isReviewable,
          translationInformation: {
            mainKeys: helpKeyArray.concat(...appConfigurationTranslationDefinition.mainKeys),
            plainTextKeysToTranslate: appConfigurationTranslationDefinition.plainTextKeysToTranslate,
            htmlKeysToTranslate: helpKeyArray.concat(...appConfigurationTranslationDefinition.htmlKeysToTranslate),
          },
        }
        this.appIdAppConfigurationInformationMap.set(appId, appConfigurationInformation)
      }
    }
    for (const appId of appIdsWithoutHelp) {
      if (!this.appIdAppConfigurationInformationMap.has(appId)) {
        console.warn(`No app configuration information found for app id ${appId}`)
      }
    }
    for (const appId of appIdsWithoutReviewableCustomContent) {
      if (!this.appIdAppConfigurationInformationMap.has(appId)) {
        console.warn(`No app configuration information found for app id ${appId}`)
      }
    }
  }

  getAppConfigurationInformation(appId: string): AppConfigurationInformation | undefined {
    return this.appIdAppConfigurationInformationMap.get(appId)
  }

  hasStudentHelp(appId: string): boolean {
    const appConfigurationInformation = this.getAppConfigurationInformation(appId)
    return appConfigurationInformation?.hasStudentHelp ?? false
  }

  isReviewable(appId: string): boolean {
    const appConfigurationInformation = this.getAppConfigurationInformation(appId)
    return appConfigurationInformation?.hasReviewableCustomContent ?? false
  }

  canTranslate(url: string): boolean {
    const fileName = url.split('/').pop()
    if (!fileName) {
      return false
    }
    const appId = this.appIdService.getAppId(url)
    if (!appId) {
      return false
    }
    const appConfigurationInformation = this.appIdAppConfigurationInformationMap.get(appId)
    if (!appConfigurationInformation) {
      return false
    }
    return appConfigurationInformation.translationInformation.mainKeys.length > 0
  }
}
